import React from "react";
import MSBUniversity from "./msb-university";
import TutorialDetail from "../../../parts/modals/tutorial-detail";
import defaults from "lodash/defaults";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";

const MSBUniversityController = async ({ res, req, load, locals }) => {
  defaults(req.query, {
    product: "general",
  });

  const { query = {} } = req;
  const { modal = {} } = query;

  await load("tutorialCategories", query.product);
  await load("tutorialVideos", {
    category: "All",
    product: query.product,
  });

  const getTutorial = (tutorialId) => {
    const tutorial = locals.tutorialVideos.find(
      (tutorial) => tutorial._id === tutorialId
    );
    return tutorial;
  };

  locals.modal = {
    "tutorial-detail": (
      <TutorialDetail selectedTutorial={getTutorial(query.selectedTutorial)} />
    ),
    "activity-feed": <ActivityDrawer />,
  }[modal.type];

  res.body = (
    <MSBUniversity
      allCategories={locals.tutorialCategories}
      allVideos={locals.tutorialVideos}
    />
  );
};

export default MSBUniversityController;
